module.exports = __webpack_public_path__ + "img/tmp2.81feb55f.png";